export const mediaToVideoBlock = (mediaItem, currentSource) => {
  const {
    url,
    mimetype,
    contentType,
    size,
    playback,
    downloadURL,
    thumb,
    muxVideoID
  } = mediaItem
  // Support legacy media items
  const mediaType = !!contentType ? contentType : mimetype || "video/*"
  const type = mediaType.split("/")[1] // 2nd half of mimetype, ex: "mp4"

  return {
    ...currentSource,
    streamURL: url,
    downloadURL,
    height: size && size.height,
    width: size && size.width,
    length: playback && playback["length"],
    type,
    coverImage: "",
    originalThumb: (thumb && thumb.original) || "",
    allowDownload: false,
    muxVideoID
  }
}
